var ubian = ubian || {};

ubian.cart = {
  hideSummaryBar: function() {
    document.cookie = "ub_cart_summary_close=1;path=/";
    $(".basket-summary").fadeOut();
  },
  unhideSummaryBar: function(){
      document.cookie = 'ub_cart_summary_close=0;path=/;expires=Sat, 01 Jan 2000 00:00:00 GMT';
  }
};
